module.exports = __webpack_public_path__ + "img/welcome.140de9b7.png";